<script lang="ts">
	import { showParaModal } from '$lib/user/para/store';

	let ParaModalComponent: any = null;
	let componentLoaded = false;

	// Load ParaModal component dynamically only when modal is shown
	$: if ($showParaModal && !ParaModalComponent && !componentLoaded) {
		import('./ParaModal.svelte').then((module) => {
			ParaModalComponent = module.default;
			componentLoaded = true;
		});
	}
</script>

{#if $showParaModal && ParaModalComponent && componentLoaded}
	<svelte:component this={ParaModalComponent} />
{/if}
